import { createSlice } from "@reduxjs/toolkit";
import { getUsers, getUserById, addUser, updateUser, deleteUsers } from "./actions";
import { IUsersState } from "./types";

const initialState: IUsersState = {
  loading: {
    getUsers: false,
    getUserById: false,
    addUser: false,
    updateUser: false,
    deleteUsers: false,
  },
  users: [],
  selectedUser: null,
  error: null,
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    clearUserState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.loading.getUsers = true;
    });
    builder.addCase(getUsers.rejected, (state) => {
      state.loading.getUsers = false;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.loading.getUsers = false;
      state.users = action.payload;
    });
    builder.addCase(getUserById.pending, (state) => {
      state.loading.getUserById = true;
    });
    builder.addCase(getUserById.rejected, (state) => {
      state.loading.getUserById = false;
    });
    builder.addCase(getUserById.fulfilled, (state, action) => {
      state.loading.getUserById = false;
      state.selectedUser = action.payload;
    });
    builder.addCase(addUser.pending, (state) => {
      state.loading.addUser = true;
    });
    builder.addCase(addUser.rejected, (state) => {
      state.loading.addUser = false;
    });
    builder.addCase(addUser.fulfilled, (state) => {
      state.loading.addUser = false;
    });
    builder.addCase(updateUser.pending, (state) => {
      state.loading.updateUser = true;
    });
    builder.addCase(updateUser.rejected, (state) => {
      state.loading.updateUser = false;
    });
    builder.addCase(updateUser.fulfilled, (state) => {
      state.loading.updateUser = false;
    });
    builder.addCase(deleteUsers.pending, (state) => {
      state.loading.deleteUsers = true;
    });
    builder.addCase(deleteUsers.rejected, (state) => {
      state.loading.deleteUsers = false;
    });
    builder.addCase(deleteUsers.fulfilled, (state) => {
      state.loading.deleteUsers = false;
    });
  },
});

export const { clearUserState } = usersSlice.actions;

